/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "446")


  
    
export interface API48231Item {
  
  /**  */
  code?: number;
  
  /**  */
  desc?: string;
  
};
    
  



  export type API48231Req = {};



export interface API48231Res {
  /** T  */
  list?: API48231Item[];
  
};


// 48231 任务状态枚举列表

export interface IUseGetAPI48231Return {
  /** 任务状态枚举列表: 接口请求状态 */
  isAPI48231Loading: boolean;
  /** 任务状态枚举列表: 接口请求返回数据 */
  dataAPI48231: API48231Res;
  /**  任务状态枚举列表: 接口数据请求方法 */
  fetchAPI48231Data:  ( config?: YWRequestConfig) => Promise<API48231Res>;
  /** 任务状态枚举列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48231 = ():IUseGetAPI48231Return => {
  let isMount = true;
  const [isAPI48231Loading, setIsAPI48231Loading] = useState(false);
  const [dataAPI48231, setDataAPI48231] = useState<API48231Res>({} as API48231Res);
  const requestUrl = `${basePath}/team-work/workTask/listWorkTaskStatusEnum`;

  const fetchAPI48231Data = async ( config?: YWRequestConfig): Promise<API48231Res> => {
  
    if ( isMount ) {
      setIsAPI48231Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48231Res>(`${basePath}/team-work/workTask/listWorkTaskStatusEnum`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48231(res || {} as API48231Res);
        setIsAPI48231Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48231Loading(false);
      }
      return false as unknown as API48231Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48231Loading,
    dataAPI48231,
    fetchAPI48231Data,
    requestUrl,
  }
}

